import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Eye, EyeSlash } from "@phosphor-icons/react";

function formatErr(detail) {
  if (detail == null) return "Algo salió mal. Intenta de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").join(" ");
  return String(detail);
}

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const redirect = params.get("redirect") || "/";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await login(email.trim(), password);
      navigate(redirect);
    } catch (err) {
      setError(formatErr(err.response?.data?.detail));
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20" data-testid="login-page">
      <div className="text-center mb-10">
        <div className="font-serif text-3xl text-stone-900">Bienvenido de nuevo</div>
        <p className="text-stone-500 mt-2">Inicia sesión en Luxe Aroma Scents</p>
      </div>
      <form onSubmit={submit} className="space-y-5">
        <div>
          <label className="label-caps text-stone-500 block mb-2">Correo electrónico</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full border border-stone-300 px-4 py-3 outline-none focus:border-[#3F4E4F]" data-testid="login-email-input" />
        </div>
        <div>
          <label className="label-caps text-stone-500 block mb-2">Contraseña</label>
          <div className="relative">
            <input type={showPassword ? "text" : "password"} required value={password} onChange={(e) => setPassword(e.target.value)} className="w-full border border-stone-300 px-4 py-3 pr-12 outline-none focus:border-[#3F4E4F]" data-testid="login-password-input" />
            <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-1/2 -translate-y-1/2 text-stone-400 hover:text-stone-700" data-testid="toggle-password" aria-label="Mostrar u ocultar contraseña">
              {showPassword ? <EyeSlash size={20} /> : <Eye size={20} />}
            </button>
          </div>
          <div className="text-right mt-2">
            <Link to="/reset-password" className="text-sm text-[#3F4E4F] hover:underline" data-testid="forgot-password-link">¿Olvidó su contraseña?</Link>
          </div>
        </div>
        {error && <div className="text-[#991B1B] text-sm" data-testid="login-error">{error}</div>}
        <button type="submit" disabled={loading} className="w-full bg-[#3F4E4F] text-white py-4 hover:bg-[#2C3637] transition-colors disabled:opacity-50" data-testid="login-submit-button">
          {loading ? "Ingresando..." : "Iniciar sesión"}
        </button>
      </form>
      <p className="text-center text-sm text-stone-500 mt-6">
        ¿No tienes cuenta? <Link to="/register" className="text-[#3F4E4F] font-medium hover:underline" data-testid="go-register-link">Regístrate</Link>
      </p>
    </div>
  );
}
